import React from 'react';
import ChatUserImage from './chatUserImage';
// import ChatInfo from './chatInfo';
// import DropDown from 'components/dropdown';
import {useNavigate} from 'react-router';

import ChatInfo from './chatInfo';
import moment from 'jalali-moment';

interface ChatItemProps {
  id: string;
  name: string;
  is_online: boolean;
  last_message_text: string;
  created_at: string;
  optionsChatItem: Array<object>;
  image: string | null;
  count_msg: number;
}
const ChatItem = ({
  id,
  name,
  is_online,
  last_message_text,
  created_at,
  image,
  optionsChatItem,
  count_msg,
}: ChatItemProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex  w-full h-[61px]  cursor-pointer">
      <div
        className="w-full"
        onClick={() =>
          navigate(`/chat-form/${id}`, {
            state: {
              supplierGuid: id,
            },
          })
        }
      >
        <div className="w-full flex gap-2">
          <ChatUserImage is_online={false} image={image} />
          <ChatInfo
            count_msg={count_msg}
            time_last_msg={created_at && timeFromCreated(created_at)}
            name={name}
            last_message_text={last_message_text}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatItem;
const timeFromCreated = (createdAt: string) => {
  const dateTime = moment(moment(new Date(createdAt)))
    .locale('fa')
    .fromNow();
  return dateTime;
};
